// generated with @7nohe/openapi-react-query-codegen@2.0.0

import { type Options } from "@hey-api/client-fetch";
import {
  useMutation,
  UseMutationOptions,
  useQuery,
  UseQueryOptions,
} from "@tanstack/react-query";
import {
  createTranslationJob,
  getDocumentAiAnalyzeIdResults,
  getDocumentAiAnalyzeIdStatus,
  getDocumentAiResults,
  getDocumentAiStatus,
  getTranslationJob,
  polishMessage,
  reprocessDocumentAi,
  translateMessage,
} from "../requests/services.gen";
import {
  CreateTranslationJobData,
  CreateTranslationJobError,
  GetDocumentAiAnalyzeIdResultsData,
  GetDocumentAiAnalyzeIdResultsError,
  GetDocumentAiAnalyzeIdStatusData,
  GetDocumentAiAnalyzeIdStatusError,
  GetDocumentAiResultsData,
  GetDocumentAiResultsError,
  GetDocumentAiStatusData,
  GetDocumentAiStatusError,
  GetTranslationJobData,
  GetTranslationJobError,
  PolishMessageData,
  PolishMessageError,
  ReprocessDocumentAiData,
  ReprocessDocumentAiError,
  TranslateMessageData,
  TranslateMessageError,
} from "../requests/types.gen";
import * as Common from "./common";
export const useGetDocumentAiStatus = <
  TData = Common.GetDocumentAiStatusDefaultResponse,
  TError = GetDocumentAiStatusError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetDocumentAiStatusData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetDocumentAiStatusKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getDocumentAiStatus({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetDocumentAiResults = <
  TData = Common.GetDocumentAiResultsDefaultResponse,
  TError = GetDocumentAiResultsError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetDocumentAiResultsData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetDocumentAiResultsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getDocumentAiResults({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetDocumentAiAnalyzeIdStatus = <
  TData = Common.GetDocumentAiAnalyzeIdStatusDefaultResponse,
  TError = GetDocumentAiAnalyzeIdStatusError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetDocumentAiAnalyzeIdStatusData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetDocumentAiAnalyzeIdStatusKeyFn(
      clientOptions,
      queryKey
    ),
    queryFn: () =>
      getDocumentAiAnalyzeIdStatus({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetDocumentAiAnalyzeIdResults = <
  TData = Common.GetDocumentAiAnalyzeIdResultsDefaultResponse,
  TError = GetDocumentAiAnalyzeIdResultsError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetDocumentAiAnalyzeIdResultsData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetDocumentAiAnalyzeIdResultsKeyFn(
      clientOptions,
      queryKey
    ),
    queryFn: () =>
      getDocumentAiAnalyzeIdResults({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetTranslationJob = <
  TData = Common.GetTranslationJobDefaultResponse,
  TError = GetTranslationJobError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetTranslationJobData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetTranslationJobKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getTranslationJob({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useReprocessDocumentAi = <
  TData = Common.ReprocessDocumentAiMutationResult,
  TError = ReprocessDocumentAiError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<ReprocessDocumentAiData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<ReprocessDocumentAiData, true>, TContext>({
    mutationKey: Common.UseReprocessDocumentAiKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      reprocessDocumentAi(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useTranslateMessage = <
  TData = Common.TranslateMessageMutationResult,
  TError = TranslateMessageError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<TranslateMessageData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<TranslateMessageData, true>, TContext>({
    mutationKey: Common.UseTranslateMessageKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      translateMessage(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const usePolishMessage = <
  TData = Common.PolishMessageMutationResult,
  TError = PolishMessageError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<PolishMessageData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<PolishMessageData, true>, TContext>({
    mutationKey: Common.UsePolishMessageKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      polishMessage(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateTranslationJob = <
  TData = Common.CreateTranslationJobMutationResult,
  TError = CreateTranslationJobError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<CreateTranslationJobData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<CreateTranslationJobData, true>, TContext>(
    {
      mutationKey: Common.UseCreateTranslationJobKeyFn(mutationKey),
      mutationFn: (clientOptions) =>
        createTranslationJob(clientOptions) as unknown as Promise<TData>,
      ...options,
    }
  );
